import React, { useMemo, useCallback } from 'react';
import FormPath from '../form_path.jsx';
import { entryKeyOf, scrollToEntryKey } from '../continuous_flow.jsx';
import { useFlowStore, useUiStore, useFlowRegistry } from '../../store/react';
import { selectCurrentItem } from '../../store/selectors';

export default function FormPathWrapper() {
    const registry = useFlowRegistry();
    const path = useFlowStore((s) => s.path);
    const canFreelyNavigate = useFlowStore((s) => s.canFreelyNavigate);
    const currentItem = useFlowStore((s) => selectCurrentItem(s, registry));
    const jumpTo = useFlowStore((s) => s.jumpTo);
    const continuousMode = useUiStore((s) => s.continuousMode);
    const currentFlow = useFlowStore((s) => registry.get(s.currentFlowId));
    const items = useMemo(
        () => Object.fromEntries(((currentFlow && currentFlow.items) || []).map((i) => [i.id, i])),
        [currentFlow]
    );
    // In continuous mode every question is already on the page and the engine follows
    // the reader down it, so navigating means scrolling: jumping the engine backwards
    // would be undone immediately by that same auto-advance, and the click would look
    // like it did nothing. Falls through to a real jump when the target is not on the
    // page (still below the reveal frontier).
    const onNavigate = useCallback((msg) => {
        const pathItem = msg.pathItem;
        const itemId = (pathItem && pathItem.itemId) || msg.nextItemId;
        if (continuousMode) {
            const loop = pathItem && pathItem.loop;
            const scrolled = scrollToEntryKey(entryKeyOf({
                item: { id: itemId },
                loopName: loop && loop.loopName,
                loopIndex: loop && loop.loopIndex,
            }));
            if (scrolled) return;
        }
        jumpTo({ itemId, path: msg.path, loop: pathItem && pathItem.loop });
    }, [jumpTo, continuousMode]);
    return (
        <FormPath
            path={path}
            canFreelyNavigate={canFreelyNavigate}
            currentItem={currentItem}
            items={items}
            onNavigate={onNavigate}
        />
    );
}
